"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToElement = void 0;
const scrollToElement = (element) => {
    if (element !== null) {
        const top = Math.round(element.getBoundingClientRect().top + window.scrollY);
        const left = 0;
        if (top - window.scrollY !== 0) {
            window.scrollTo({ top, left, behavior: 'smooth' });
        }
    }
};
exports.scrollToElement = scrollToElement;
//# sourceMappingURL=dom.js.map